import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { TenantConfigService } from './tenant-config.service';

/**
 * Aplica los tokens de tema del tenant como CSS variables en <html>,
 * para que los estilos globales puedan referenciarlos con var(--tenant-*).
 *
 * Llamar a `applyTheme()` luego de `TenantConfigService.load()`
 * (lo hacemos desde APP_INITIALIZER).
 */
@Injectable({
    providedIn: 'root'
})
export class TenantThemeService {
    private readonly document = inject(DOCUMENT);
    private readonly tenantConfig = inject(TenantConfigService);

    applyTheme(): void {
        const theme = this.tenantConfig.snapshot.theme;

        if (!theme) {
            return;
        }

        const root = this.document.documentElement;
        const tokens = theme.tokens ?? {};

        if (tokens.colorPrimary) {
            root.style.setProperty('--tenant-color-primary', tokens.colorPrimary);
        }
        if (tokens.colorSecondary) {
            root.style.setProperty('--tenant-color-secondary', tokens.colorSecondary);
        }
        if (tokens.borderRadius) {
            root.style.setProperty('--tenant-border-radius', tokens.borderRadius);
        }
        if (tokens.fontFamily) {
            root.style.setProperty('--tenant-font-family', tokens.fontFamily);
        }
    }
}
